import { all } from 'redux-saga/effects';
import todoSagas from './todo/saga';
// import chatSagas from './chat/saga';
// import surveyListSagas from './surveyList/saga';
// import surveyDetailSagas from './surveyDetail/saga';
import dummySagas from './dummy/saga';

import authSagas from './auth/saga';
import absenceSagas from './absence/saga';
import activitySagas from './activity/saga';
import agencySagas from './agency/saga';
import agencyConfigSagas from './agencyconfig/saga';
import budgetCategorySagas from './budgetcategory/saga';
import confirmationSagas from './confirmation/saga';
import costUserSagas from './costuser/saga';
import dayOffSagas from './dayoff/saga';
import disciplineSagas from './discipline/saga';
import executorSagas from './executor/saga';
import financePersonSagas from './financeperson/saga';
import instructionSagas from './instruction/saga';
import jobDescriptionSagas from './jobdescription/saga';
import memberSagas from './member/saga';
import memberClassSagas from './memberclass/saga';
import notificationSagas from './notification/saga';
import performanceSagas from './performance/saga';
import positionSagas from './position/saga';
import positionClassSagas from './positionclass/saga';
import presenceSagas from './presence/saga';
import taskSagas from './task/saga';
import taskCategorySagas from './taskcategory/saga';
import taskClassificationSagas from './taskclassification/saga';
import userSagas from './user/saga';
import wbsSagas from './wbs/saga';
import workTimeStandardSagas from './worktimestandard/saga';
import workUnitSagas from './workunit/saga';

export default function* rootSaga() {
  yield all([
    authSagas(),
    todoSagas(),
    // chatSagas(),
    // surveyListSagas(),
    // surveyDetailSagas(),
    dummySagas(),

    absenceSagas(),
    activitySagas(),
    agencySagas(),
    agencyConfigSagas(),
    budgetCategorySagas(),
    confirmationSagas(),
    costUserSagas(),
    dayOffSagas(),
    disciplineSagas(),
    executorSagas(),
    financePersonSagas(),
    instructionSagas(),
    jobDescriptionSagas(),
    memberSagas(),
    memberClassSagas(),
    notificationSagas(),
    performanceSagas(),
    positionSagas(),
    positionClassSagas(),
    presenceSagas(),
    taskSagas(),
    taskCategorySagas(),
    taskClassificationSagas(),
    userSagas(),
    wbsSagas(),
    workTimeStandardSagas(),
    workUnitSagas(),

  ]);
}
